<template>
  <div id="page" class="step-form">
    <Header />
    <main class="main">
      <form class="section-form icw-form" method="POST">
        <div class="section-progressbar">
          <div class="container">
            <ul class="bar-step">
              <li
                class="active done"
                :onclick="'window.location.href=\'' + info + '\''"
              >
                ข้อมูลส่วนตัว
              </li>
              <li
                class="active done"
                :onclick="'window.location.href=\'' + wealth + '\''"
              >
                การเงิน
              </li>
              <li
                class="active"
                :onclick="'window.location.href=\'' + health + '\''"
              >
                สุขภาพ
              </li>
              <li>ผลประเมิน</li>
            </ul>
            <ul class="bar-list list3" id="progressbar">
              <li
                v-for="(v, i) in ProgressLength"
                :key="i"
                :class="{ active: currentStep >= v }"
              ></li>
            </ul>
          </div>
        </div>

        <div class="section-fieldset">
          <div class="section-fieldset-wrapper">
            <div class="section-fieldset-inner">
              <div class="container">
                <div class="fieldset-group" v-if="setupAutoData">
                  <Q18 :QuestionType="'Resolve'" />
                </div>
                <div class="fieldset-group" v-else>
                  <Q1 :QuestionType="'HealthInfo'" />
                  <!-- Health Info -->
                  <Q2 :QuestionType="'WorkoutRate'" />
                  <!-- Workout Rate -->
                  <Q3 :QuestionType="'WorkoutTime'" />
                  <!-- Workout Time -->
                  <Q4 :QuestionType="'RelaxTime'" />
                  <!-- Relax Time -->
                  <Q5 :QuestionType="'WakeupFreq'" />
                  <!-- Wake up Frequency -->
                  <Q6 :QuestionType="'RideFreq'" />
                  <!-- Ride Frequency -->
                  <Q7 :QuestionType="'HangoutFreq'" />
                  <!-- Hangout Frequency -->
                  <Q8 :QuestionType="'UseMobilePhone'" />
                  <!-- Use Mobile Phone Frequency -->
                  <Q9 :QuestionType="'Cigarrete'" />
                  <!-- Cigarrete -->
                  <Q10 :QuestionType="'Cancer'" />
                  <!-- Cancer -->
                  <Q11 :QuestionType="'EatHotdog'" />
                  <!-- Eat HotDog -->
                  <Q12 :QuestionType="'MilkTea'" />
                  <!-- Milk Tea -->
                  <Q13 :QuestionType="'Fried'" />
                  <!-- Fried -->
                  <Q14 :QuestionType="'Noodle'" />
                  <!-- Noodle -->
                  <Q15 :QuestionType="'Bored'" />
                  <!-- Bored -->
                  <Q16 :QuestionType="'Dismal'" />
                  <!-- Dismal -->
                  <Q17 :QuestionType="'NotFocus'" />
                  <!-- Not Focus -->
                  <Q18 :QuestionType="'Resolve'" />
                  <!-- Resolve -->
                </div>
              </div>
            </div>
          </div>
          <div class="section-fieldset-button"></div>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";

import MyConfig from "@/../me.config.js";

import {
  getCurrentStep,
  my_range,
  my_storage
} from "@/helpers/global_helper.js";

import Header from "@/components/Header.vue";

import Q1 from "@/components/QuestionStep3/STEP3-Q1.vue";
import Q2 from "@/components/QuestionStep3/STEP3-Q2.vue";
import Q3 from "@/components/QuestionStep3/STEP3-Q3.vue";
import Q4 from "@/components/QuestionStep3/STEP3-Q4.vue";
import Q5 from "@/components/QuestionStep3/STEP3-Q5.vue";
import Q6 from "@/components/QuestionStep3/STEP3-Q6.vue";
import Q7 from "@/components/QuestionStep3/STEP3-Q7.vue";
import Q8 from "@/components/QuestionStep3/STEP3-Q8.vue";
import Q9 from "@/components/QuestionStep3/STEP3-Q9.vue";
import Q10 from "@/components/QuestionStep3/STEP3-Q10.vue";
import Q11 from "@/components/QuestionStep3/STEP3-Q11.vue";
import Q12 from "@/components/QuestionStep3/STEP3-Q12.vue";
import Q13 from "@/components/QuestionStep3/STEP3-Q13.vue";
import Q14 from "@/components/QuestionStep3/STEP3-Q14.vue";
import Q15 from "@/components/QuestionStep3/STEP3-Q15.vue";
import Q16 from "@/components/QuestionStep3/STEP3-Q16.vue";
import Q17 from "@/components/QuestionStep3/STEP3-Q17.vue";
import Q18 from "@/components/QuestionStep3/STEP3-Q18.vue";
window.jQuery = window.$ = jQuery;

require("@/assets/theme/js/library/jquery.easing.1.3.min.js");
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

require("@/assets/theme/plugin/bootstrap/bootstrap.min.js");

Vue.mixin({
  data: function() {
    return {
      isError: false,
      wrongFormat: false
    };
  }
});

export default {
  name: "Step3",
  mounted() {
    this.$nextTick(() => {
      require("@/assets/theme/js/theme.js");
    });
    if (!JSON.parse(sessionStorage.getItem("Information"))) {
      window.location.href = MyConfig.InfoPath;
    }
    let a = sessionStorage.getItem("MoneyHealth8");
    let skip = sessionStorage.getItem("skipQuize10");
    if (skip == null && !a) {
      window.location.href = MyConfig.WealthPath;
    }
  },
  components: {
    Header,
    Q1,
    Q2,
    Q3,
    Q4,
    Q5,
    Q6,
    Q7,
    Q8,
    Q9,
    Q10,
    Q11,
    Q12,
    Q13,
    Q14,
    Q15,
    Q16,
    Q17,
    Q18
  },
  data() {
    return {
      currentStep: getCurrentStep("step3"),
      ProgressLength: my_range(1, 18),
      info: MyConfig.InfoPath,
      wealth: MyConfig.WealthPath,
      health: MyConfig.HealthPath,
      setupAutoData: my_storage("setup", "auto")
    };
  },
  methods: {
    GoTo(step) {
      return this.$router.push(step);
    }
  },
  watch: {
    currentStep: function(n, o) {
      this.ProgressLength = my_range(1, 18);
    }
  }
};
</script>
